import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const markRead = async ({ id }) => {
  const { data } = await axiosInstance.post(`/notifications/${id}/mark_read/`);
  return data;
};

export const useMarkRead = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: markRead,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { markRead: mutation.mutateAsync, ...mutation };
};
